<form #tableForm="ngForm" class="atm">
  <header class="atm-head">
    <button type="button" class="atm-close" (click)="cancel()" aria-label="Close">
      <i class="bx bx-x" aria-hidden="true"></i>
    </button>
    <h2 class="atm-title">
      @if (table) {
        Edit {{ table.table_name }}
      } @else {
        Add New Table
      }
    </h2>
    <button
      type="button"
      class="atm-save"
      [disabled]="tableForm.invalid || isDuplicate || !zone"
      (click)="save(tableName)"
    >
      Save Table
    </button>
  </header>

  <div class="atm-body">
    <!-- Basic info -->
    <section class="atm-card">
      <header class="atm-card-head">
        <span class="atm-card-icon"><i class="bx bx-file" aria-hidden="true"></i></span>
        <div>
          <h3 class="atm-card-title">Basic Info</h3>
          <p class="atm-card-sub">Provide basic details to add a new table.</p>
        </div>
      </header>

      <label class="atm-label" for="tableName">Table Name *</label>
      <input
        autoComplete="off"
        type="text"
        class="atm-input"
        placeholder="e.g. Table 11"
        id="tableName"
        name="tableName"
        [(ngModel)]="tableName1"
        #tableName="ngModel"
        required
        maxlength="6"
        minlength="2"
        pattern="[a-zA-Z0-9-_]+"
        (input)="onTableNameInput($event)"
        [ngClass]="{
          'input-error':
            (tableName.invalid && (tableName.dirty || tableName.touched)) ||
            checkDuplicateTableNameValidation(),
        }"
      />

      @if (
        tableName.invalid &&
        tableName.errors?.['required'] &&
        (tableName.dirty || tableName.touched)
      ) {
        <div class="d-flex mt-2 errorText gap-2">
          <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
          <p>Table name cannot be empty.</p>
        </div>
      }
      @if (
        tableName.invalid &&
        tableName.errors?.['maxlength'] &&
        (tableName.dirty || tableName.touched)
      ) {
        <div class="d-flex mt-2 errorText gap-2">
          <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
          <p>Table name must be within 6 characters.</p>
        </div>
      }
      @if (
        tableName.invalid &&
        tableName.errors?.['minlength'] &&
        (tableName.dirty || tableName.touched)
      ) {
        <div class="d-flex mt-2 errorText gap-2">
          <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
          <p>Table name must be greater than 2 characters.</p>
        </div>
      }
      @if (
        tableName.invalid && tableName.errors?.['pattern'] && (tableName.dirty || tableName.touched)
      ) {
        <div class="d-flex mt-2 errorText gap-2">
          <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
          <p>Table name can only contain letters, numbers, hyphens, and underscores.</p>
        </div>
      }
      @if (checkDuplicateTableNameValidation()) {
        <div class="d-flex mt-2 errorText gap-2">
          <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
          <p>Table name is already existing.</p>
        </div>
      }

      <span class="atm-label atm-label--spaced">Max Pax *</span>
      <div class="atm-chips">
        @for (chair of chairsList; track chair.count) {
          <button
            type="button"
            class="atm-chip"
            [class.atm-chip--active]="chair.isChecked"
            (click)="selectChair(chair)"
          >
            {{ chair.displayCount }}
          </button>
        }
      </div>
    </section>

    <!-- Zone -->
    @if (zones.length > 0) {
      <section class="atm-card">
        <header class="atm-card-head">
          <span class="atm-card-icon"><i class="bx bx-map-pin" aria-hidden="true"></i></span>
          <div>
            <h3 class="atm-card-title">Zone</h3>
            <p class="atm-card-sub">Select the zone for this table.</p>
          </div>
        </header>

        <div class="atm-readout">{{ zone?.zone || 'No zone selected' }}</div>

        <span class="atm-eyebrow">Quick options</span>
        <div class="atm-chips">
          @for (z of zones; track z.zone) {
            <button
              type="button"
              class="atm-chip atm-chip--wide"
              [class.atm-chip--active]="z.isChecked"
              (click)="selectZone(z)"
            >
              {{ z.zone }}
            </button>
          }
        </div>
        @if (!zone) {
          <div class="d-flex mt-2 errorText gap-2">
            <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
            <p>Please select a zone.</p>
          </div>
        }
      </section>
    }

    <!-- Shape -->
    <section class="atm-card">
      <header class="atm-card-head">
        <span class="atm-card-icon"><i class="bx bx-layer" aria-hidden="true"></i></span>
        <div>
          <h3 class="atm-card-title">Table Shape</h3>
          <p class="atm-card-sub">Select the shape of the table.</p>
        </div>
      </header>

      <div class="atm-shapes">
        @for (shape of shapeList; track shape.shape) {
          <button
            type="button"
            class="atm-shape"
            [class.atm-shape--active]="shape.isChecked"
            (click)="selectShape(shape)"
          >
            <i class="bx" [ngClass]="shapeIcon(shape.shape)" aria-hidden="true"></i>
            <span>{{ shape.shape }}</span>
          </button>
        }
      </div>

      <div class="atm-preview">
        <span class="atm-eyebrow">Shape preview</span>
        <div class="atm-canvas-panel">
          <canvas #canvas width="400" height="260" class="atm-canvas"></canvas>
        </div>
      </div>
    </section>
  </div>
</form>
